export const AMBIGUOUS_TRADE_MODAL_TEST_IDS = {
  MODAL: "ambiguous-trade-modal",
  CONFIRM_SELECTED: "ambiguous-trade-modal-confirm-selected",
  CONFIRM_ALTERNATIVE: "ambiguous-trade-modal-confirm-alternative",
  SELECT_ANOTHER: "ambiguous-trade-modal-select-another",
} as const;
